import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LeadActivityListService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/leadActivityList";

  LeadActivityList(Page: number, size: number, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  getAllLeadActivityListDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  LeadActivityListSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }

  getLeadActivityListById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }
  syncLeadActivityListPageData() {
    return this.http.get(`${this.url}/page/sync`);
  }


  public responseCache = new Map();

  public getAllLeadActivityListDropDownCache(): Observable<any> {

    const leadStatusFromCache = this.responseCache.get(`${this.url}/dropdown`);

    if (leadStatusFromCache) {
      return of(leadStatusFromCache);
    } else {
      return this.http.get<any>(`${this.url}/dropdown`).pipe(
        tap(leadStatus => this.responseCache.set(`${this.url}/dropdown`, leadStatus))
      );
    }

  }


  newLeadActivityList(leadStatus: any): Observable<any> {
    return this.http.post<any>(`${this.url}`, leadStatus).pipe(
      tap(() => this.delete())
    );
  }

  delete() {
    this.responseCache.delete(`${this.url}`)
  }
}
